import React from "react";
import Webcam from "react-webcam";
import DetectRTC from "detectrtc";
import PropTypes from "prop-types";

export default class WebcamCapture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenshot: null,
      havePermissions: false
    };
    this.saveAndUpload = this.saveAndUpload.bind(this);
  }
  handleCapture() {
    const screenshot = this.webcam.getScreenshot();
    this.setState({ screenshot });
  }
  handleReset() {
    this.setState({
      screenshot: null
    });
  }
  saveAndUpload() {
    let imgSrc = document.getElementById("image-capture-preview").src;
    this.props.uploadImage(imgSrc);
  }
  componentWillMount() {
    DetectRTC.load(() => {
      if (DetectRTC.hasWebcam === false) {
        alert("Please install an external webcam device.");
      }
    });
  }
  render() {
    return (
      <div>
        {!this.state.screenshot ? (
          <>
            <Webcam
              audio={false}
              ref={(node) => (this.webcam = node)}
              height={350}
              screenshotFormat="image/jpeg"
              width={350}
              className="profile-image-preview profile-image-live-preview"
            />
            <button onClick={this.handleCapture.bind(this)} className="webcam-image-capture">
              {this.props.cta}
            </button>
          </>
        ) : (
          <>
            <img
              id="image-capture-preview"
              className={`profile-image-preview`}
              src={this.state.screenshot}
            />
            <button onClick={this.saveAndUpload} className="webcam-image-save">
              Save
            </button>
            <button onClick={this.handleReset.bind(this)} className="webcam-image-retake">
              Re-take
            </button>
          </>
        )}
      </div>
    );
  }
}
WebcamCapture.propTypes = {
  cta: PropTypes.string,
  uploadImage: PropTypes.func.isRequired
};

WebcamCapture.defaultProps = {
  uploadImage: () => null
};
